import { render } from "./PeachFr.vue?vue&type=template&id=0a1631a0"
import script from "./PeachFr.vue?vue&type=script&lang=js"
export * from "./PeachFr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__